import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'

const badgeVariants = cva(
  'inline-flex min-h-6 w-fit items-center rounded-full border px-2 py-0.5 text-xs capitalize transition-color',
  {
    variants: {
      color: {
        gray: 'bg-surface text-body-foreground',
        blue: 'border-accent/40 bg-accent/10 text-accent',
        orange: 'border-warning/40 bg-warning/10 text-warning',
        green: 'border-success/40 bg-success/10 text-success',
        red: 'border-destructive/40 bg-destructive/10 text-destructive',
      },
    },
    defaultVariants: {
      color: 'gray',
    },
  }
)

interface BadgeProps extends Omit<HTMLAttributes<HTMLDivElement>, 'color'>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, color, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ color }), className)} {...props} />
}
